export default __webpack_public_path__ + "static/media/hero@2x.6e06509c.png";